import { MultilingualFactory } from '../common';
export class LanguageFactory {
    static create(props = {}) {
        return {
            code: 'ES',
            name: MultilingualFactory.create(),
            id: 1,
            showInOffer: true,
            ...props
        };
    }
    static createList(size = 1) {
        return Array.from({ length: size }).map(() => {
            return this.create();
        });
    }
}
export class LanguageFlatFactory {
    static create(props = {}) {
        return {
            code: 'ES',
            name: 'Spanish',
            id: 1,
            showInOffer: true,
            ...props
        };
    }
    static createList(size = 1) {
        return Array.from({ length: size }).map(() => {
            return this.create();
        });
    }
}
//# sourceMappingURL=language.factory.js.map